import versions from '../resources/poseVersions.json';
import portraitVersions from '../resources/portraitVersions.json';

export function avatarPosePath(avatar:unknown,catalogImage?:string,hy=false):string {
  const model=Number(avatar);
  if(hy)return `poses/${avatar}.png`;
  if(Number.isSafeInteger(model)&&model>0&&Object.prototype.hasOwnProperty.call(versions,`${model}.png`))return `poses/${model}.png`;
  return `poses/${catalogImage?.substring(8)}.png`;
}

/** Same-name replacements get a fresh URL; unchanged images retain their cache. */
export function versionedPose(src:string):string {
  const match=src.match(/(?:^|\/)poses\/([^/?#]+)/);
  const version=match&&(versions as Record<string,string>)[match[1]];
  if(!version)return src;
  const [url,fragment]=src.split('#',2),[base,query]=url.split('?',2);
  const params=new URLSearchParams(query);params.set('posev',version);
  return base+'?'+params.toString()+(fragment===undefined?'':'#'+fragment);
}

export function versionedCharacterImage(src:string):string {
  const match=src.match(/(?:^|\/)portraits\/([^/?#]+)/);
  const version=match&&(portraitVersions as Record<string,string>)[match[1]];
  if(!version)return versionedPose(src);
  const [url,fragment]=src.split('#',2),[base,query]=url.split('?',2);
  const params=new URLSearchParams(query);params.set('portraitv',version);
  return base+'?'+params.toString()+(fragment===undefined?'':'#'+fragment);
}
